module.exports = __webpack_public_path__ + "static/img/logo.ec835780.png";